module.exports = __webpack_public_path__ + "media/images/shop/kodawari2-edc4510f772d33ad6fab0a02fe0f9037.jpg";